import fetch from 'utils/fetch';

export const cancelContract = id => {
  return fetch(`/pco-manager/aast/cases/${id}/contract`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteCase = id => {
  return fetch(`/pco-manager/aast/cases-creation/${id}/delete`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/api.js